import React, { createContext, useContext, useState } from 'react';

const OrderContext = createContext();

export const useOrder = () => {
  const context = useContext(OrderContext);
  if (!context) {
    throw new Error('useOrder must be used within an OrderProvider');
  }
  return context;
};

export const OrderProvider = ({ children }) => {
  const [orderType, setOrderType] = useState('delivery'); // 'delivery' or 'pickup'
  const [customerDetails, setCustomerDetails] = useState(null);
  const [paymentProof, setPaymentProof] = useState(null);

  const MINIMUM_ORDER_DELIVERY = 250;
  const MINIMUM_ORDER_PICKUP = 0;
  const PACKAGING_CHARGE_PER_ITEM = 7;

  const EXCLUDED_CATEGORIES = [
    'Indian Breads',
    'Fresh Juices',
    'Desserts'
  ];

  const calculatePackagingCharges = (items) => {
    const chargeableItems = items.filter(item => 
      !EXCLUDED_CATEGORIES.some(cat => item.category && item.category.includes(cat))
    );
    const totalChargeableQty = chargeableItems.reduce((sum, item) => sum + item.quantity, 0);
    return totalChargeableQty * PACKAGING_CHARGE_PER_ITEM;
  };

  const getMinimumOrder = () => {
    return orderType === 'delivery' ? MINIMUM_ORDER_DELIVERY : MINIMUM_ORDER_PICKUP;
  };

  return (
    <OrderContext.Provider
      value={{
        orderType,
        setOrderType,
        customerDetails,
        setCustomerDetails,
        paymentProof,
        setPaymentProof,
        calculatePackagingCharges,
        getMinimumOrder,
        MINIMUM_ORDER_DELIVERY,
        MINIMUM_ORDER_PICKUP,
        PACKAGING_CHARGE_PER_ITEM,
      }}
    >
      {children}
    </OrderContext.Provider>
  );
};